import { Avatar, Badge, Empty, Spin, List, Typography, Icon, Drawer } from 'antd';
import _ from 'lodash';
import * as React from 'react';
import moment from 'moment';
import ReactJson from 'react-json-view';
import { truncateLongText } from 'o2o_layout';
import { IResponseBigDataVN, TypeResultsBigData, TypePageBigData } from 'o2o_layout/lib/common/interface';
import PopoverWithMasking from './PopoverWithMasking';

interface IProps {
  notifications: TypeNotifications;
  commontActionFromDAL: any;
  userDAL: any;
  urlAccount: string;
  viewAllText?: string;
}

export type TypeStatusNoti = {
  key: 'New' | 'Read';
  longValue: number;
};

export type TypeMsgLevels = {
  key: 'success' | 'error' | 'warning' | 'info';
  longValue: number;
};

export type TypeNotifications = {
  total: number;
  status: TypeStatusNoti[];
  msgLevels: any[];
  took: number;
};

export type TypeCriteriaSearchNotifications = {
  page?: number;
  order?: string;
  pageSize?: number;
};

export type TypeMessage = {
  appId: 'XDossier Console' | string;
  createdAt: number;
  errorCode: string;
  id: string;
  message: string;
  messageLevel: string;
  object: any;
  orgId: string;
  readAt: number;
  status: 'New' | 'Read';
  title: string;
  userId: string;
  visibilityLevel: string;
  requiredFix: boolean;
  solved: boolean;
  solvedAt: number;
  solvedBy: string;
};

export class NotiMessages implements IResponseBigDataVN<TypeMessage> {
  success: boolean;
  results: TypeResultsBigData<TypeMessage>;
  stats: TypeNotifications;
  constructor() {
    this.success = false;
    this.results = {
      content: [],
      currentTime: 0,
      extras: null,
      page: {
        currentPage: 0,
        pageSize: 0,
        totalPages: 0,
        totalRecords: 0,
      } as TypePageBigData,
      timeTaken: 0,
    };
    this.stats = {
      total: 0,
      status: [],
      msgLevels: [],
      took: 0,
    };
  }
}

const ListItemNoti = (props: {
  item: TypeMessage;
  commonActionDAL: any;
  renderIconMessageLevel: any;
  success: any;
  userDAL: any;
}) => {
  const { item, renderIconMessageLevel } = props;
  const [loading, setLoading] = React.useState(false);
  const markRead = () => {
    setLoading(true);
    props
      .commonActionDAL(props.userDAL, 'markReadMessage', item.id)
      .then(() => {
        props.success(item);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };
  return loading ? (
    <List.Item style={{ width: 260, position: 'relative' }}>
      <List.Item.Meta
        title={
          <span>
            {' '}
            <Icon spin={loading} type='sync' /> {truncateLongText(item.title, 30)}{' '}
            {item.status == 'New' ? (
              <span
                style={{
                  position: 'absolute',
                  right: -15,
                  top: '40%',
                }}
              >
                <Badge color='#0980EC' dot />
              </span>
            ) : null}{' '}
          </span>
        }
        description={
          <div>
            <Typography.Paragraph style={{ width: 250, marginBottom: 0 }} ellipsis={true}>
              {item.message}
            </Typography.Paragraph>
            <small>{moment(item.createdAt).fromNow()}</small>
          </div>
        }
      />
    </List.Item>
  ) : (
    <List.Item
      style={{
        width: 260,
        position: 'relative',
        cursor: 'pointer',
      }}
      onClick={() => {
        markRead();
      }}
    >
      <List.Item.Meta
        title={
          <span>
            {renderIconMessageLevel(item)} {truncateLongText(item.title, 30)}{' '}
            {item.status == 'New' ? (
              <span
                style={{
                  position: 'absolute',
                  right: -15,
                  top: '40%',
                }}
              >
                <Badge color='#0980EC' dot />
              </span>
            ) : null}{' '}
          </span>
        }
        description={
          <div>
            <Typography.Paragraph style={{ width: 250, marginBottom: 0 }} ellipsis={true}>
              {item.message}
            </Typography.Paragraph>
            <small>{moment(item.createdAt).fromNow()}</small>
          </div>
        }
      />
    </List.Item>
  );
};
const NotificationCmp = (props: IProps) => {
  const [criteria] = React.useState({
    page: 0,
    pageSize: 4,
    messageLevels: ['warning', 'error'],
    solves: [false],
  } as TypeCriteriaSearchNotifications);

  const [visible, setVisible] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [notiMessage, setNotiMessage] = React.useState(new NotiMessages());
  const [selectedNoti, setSelectedNoti] = React.useState(null as TypeMessage | null);
  const [visibleDetail, setVisibleDetail] = React.useState(false);

  React.useEffect(() => {
    load();
  }, []);

  React.useEffect(() => {
    setTimeout(() => {
      load(true);
    }, 1000);
  }, [props.notifications]);

  React.useEffect(() => {
    if (visible) {
      load();
    }
  }, [visible]);

  const load = (updateLoading?: boolean) => {
    !updateLoading ? setLoading(true) : setLoading(false);
    props
      .commontActionFromDAL(props.userDAL, 'getMessages', criteria)
      .then((e: any) => {
        !updateLoading ? setLoading(false) : setLoading(false);
        if (e.success) {
          setNotiMessage(e);
        } else {
          setNotiMessage(new NotiMessages());
        }
      })
      .catch(() => {
        !updateLoading ? setLoading(false) : setLoading(false);
        setNotiMessage(new NotiMessages());
      });
  };

  const renderIconMessageLevel = (item: TypeMessage) => {
    switch (item.messageLevel) {
      case 'success':
        return <Icon style={{ color: '#52c41a', marginRight: 5 }} type='check-circle' />;
      case 'info':
        return <Icon style={{ color: '#1890ff', marginRight: 5 }} type='info-circle' />;
      case 'warning':
        return <Icon style={{ color: '#faad14', marginRight: 5 }} type='warning' />;
      case 'error':
        return <Icon style={{ color: '#f5222d', marginRight: 5 }} type='close-circle' />;
      default:
        return null;
    }
  };

  const renderNoti = () => {
    return (
      <List
        size='small'
        footer={
          <div style={{ textAlign: 'center' }}>
            <a href={props.urlAccount} target='_notification'>
              {props.viewAllText ? props.viewAllText : 'View all in Account Messsage'}
            </a>
          </div>
        }
        style={{ width: 300, padding: '0 20px 0 20px' }}
        dataSource={notiMessage.results.content}
        pagination={false}
        renderItem={(item: TypeMessage) => {
          return (
            <List.Item style={{ width: 260, position: 'relative' }}>
              <ListItemNoti
                userDAL={props.userDAL}
                success={(item: TypeMessage) => {
                  setSelectedNoti(item);
                  setVisibleDetail(true);
                  setVisible(false);
                  setTimeout(() => {
                    load(true);
                  }, 1000);
                }}
                item={item}
                commonActionDAL={props.commontActionFromDAL}
                renderIconMessageLevel={renderIconMessageLevel}
              />
            </List.Item>
          );
        }}
      ></List>
    );
  };

  const filterMsgLevels: TypeMsgLevels = _.find(
    notiMessage.stats.msgLevels,
    (item: TypeMsgLevels) => item.key === 'error'
  );

  const renderBlinkingNoti = () => {
    return filterMsgLevels && filterMsgLevels.longValue > 0 ? (
      <svg
        height='15'
        width='15'
        style={{
          marginLeft: 2,
          position: 'absolute',
          top: 4,
          right: 14,
          animation: 'blinker 1s linear infinite',
        }}
      >
        <circle cx='7' cy='7' r='4' fill='red' stroke='#fff' />
      </svg>
    ) : null;
  };

  return (
    <React.Fragment>
      <PopoverWithMasking
        onVisibleChange={(e: boolean) => setVisible(e)}
        visible={visible}
        className='o2o-popover'
        title='Notifications'
        placement='bottomLeft'
        trigger='click'
        content={
          <Spin spinning={loading} size={'small'}>
            {notiMessage.results.content.length ? renderNoti() : <Empty />}
          </Spin>
        }
      >
        <Avatar
          shape='square'
          icon={
            <Icon
              component={() => {
                return (
                  <svg
                    width='1em'
                    height='1em'
                    viewBox='0 0 16 18'
                    fill='currentColor'
                    xmlns='http://www.w3.org/2000/svg'
                  >
                    <path
                      d='M4.87715 16.3662C5.6131 17.3017 6.76925 17.9045 8.06934 17.9045C9.36943 17.9045 10.5256 17.3017 11.2615 16.3662C9.14246 16.6533 6.99621 16.6533 4.87715 16.3662Z'
                      fill='currentColor'
                    />
                    <path
                      d='M13.9748 6.52954V7.14563C13.9748 7.885 14.1858 8.60782 14.5813 9.22301L15.5503 10.7305C16.4354 12.1075 15.7597 13.9792 14.2203 14.4147C10.1932 15.5538 5.94548 15.5538 1.9184 14.4147C0.379002 13.9792 -0.296694 12.1075 0.5884 10.7305L1.55741 9.22301C1.95284 8.60782 2.16385 7.885 2.16385 7.14563V6.52954C2.16385 3.1468 4.80782 0.404541 8.06933 0.404541C11.3308 0.404541 13.9748 3.1468 13.9748 6.52954Z'
                      fill='currentColor'
                    />
                  </svg>
                );
              }}
            />
          }
          className='application'
          style={{
            background: visible ? 'var(--primary-color)' : '#F0F2F5',
            color: visible ? '#fff' : 'var(--primary-color)',
          }}
        ></Avatar>
        {renderBlinkingNoti()}
      </PopoverWithMasking>
      <Drawer
        width={500}
        title={
          selectedNoti ? (
            <React.Fragment>
              {renderIconMessageLevel(selectedNoti)} {selectedNoti.title}
            </React.Fragment>
          ) : (
            'Notification'
          )
        }
        visible={visibleDetail}
        onClose={() => {
          setVisibleDetail(false);
          setSelectedNoti(null);
          setVisible(true);
        }}
      >
        {selectedNoti ? (
          <div>
            <p>{selectedNoti.message}</p>
            <ReactJson collapsed={true} src={selectedNoti} />
          </div>
        ) : null}
      </Drawer>
    </React.Fragment>
  );
};

export default NotificationCmp;
